<template>
  <div ref="echart" :style="{ width: width, height: height }"></div>
</template>
<script>
import changeMap from './map'
export default {
  name: 'e-chart',
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '80vw',
    },
    datas: {
      type: Object,
      default: function() {
        return {}
      },
    },
    mapIsclick: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    datas: {
      handler: function () {
        this.$nextTick(() => {
          this.initEchart()
        })
      },
      deep: true
    }
  },
  data() {
    return {}
  },
  mounted() {
    console.log('===============================',this.datas)
    this.$nextTick(() => {
      this.initEchart()
    })
  },
  methods: {
    initEchart() {
      // 获取DOM节点并初始化
      changeMap()
      console.log(window.echarts.registerMap)
      let chart = window.echarts.init(this.$refs.echart)
      // 设置图表的参数
      chart.setOption(this.datas)
      if (this.mapIsclick) {
        let that = this
        //点击事件,根据点击某个省份计算出这个省份的数据
        chart.on('click', function(params) {
          that.$emit('callBack', params)
        })
      }
      chart.resize()
    },
  },
}
</script>
